import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import {
  ADD_ALLERGY_SUCCESS,
  ADD_MEDIA_FILE_SUCCESS,
  DELETE_ALERT_SUCCESS,
  EDIT_ALERT_SUCCESS,
  GET_MEDIA_FILES_SUCCESS,
  GET_PATIENT_INFO_SUCCESS,
  GET_PATIENT_PAST_VISITS_SUCCESS,
  GET_PATIENT_UPCOMING_VISITS_SUCCESS,
  GET_PATIENTS_LIST_SUCCESS,
  SET_MEDIA_FILE_TAGS_SUCCESS,
  SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  UPDATE_ACCOUNT_INFO_SUCCESS,
} from './ChartsConstants'
import { getAlertsList, getMediaFiles, getPatientInfo } from './ChartsThunk'
import { setNewPatientsList } from './ChartsActions'

export const ChartListener = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  closeAlertSection,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  openPastVisits,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  openUpcomingVisits,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  openFiles,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  closeTagsPopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  closeUpload,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tabId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onClearForm,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action, listenerApi) => {
          switch (action.type) {
            case ADD_ALLERGY_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.tabId === tabId) {
                onClearForm()
              }
              break
            case SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.tabId === tabId) {
                onClearForm()
              }
              break
            case GET_PATIENTS_LIST_SUCCESS:
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              listenerApi.dispatch(setNewPatientsList(action.payload))
              break
            case GET_PATIENT_PAST_VISITS_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.patientId === patientId) {
                openPastVisits()
              }
              break
            case GET_PATIENT_UPCOMING_VISITS_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.patientId === patientId) {
                openUpcomingVisits()
              }
              break
            case GET_MEDIA_FILES_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.patientId === patientId) {
                openFiles()
              }
              break
            case GET_PATIENT_INFO_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.patientId === patientId && !!action.extraData.mediaFiles) {
                listenerApi.dispatch(
                  // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
                  getMediaFiles({
                    patientId,
                    mediaFiles: [],
                  }),
                )
              }
              break
            case UPDATE_ACCOUNT_INFO_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.patientId === patientId) {
                // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
                listenerApi.dispatch(getPatientInfo(patientId, action.extraData.mediaFiles))
              }
              break
            case SET_MEDIA_FILE_TAGS_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.patientId === patientId) {
                closeTagsPopUp()
                // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
                listenerApi.dispatch(getPatientInfo(patientId))
              }
              break
            case DELETE_ALERT_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (patientId === action.extraData.patientId) getAlertsList(action.extraData.patientId)
              break
            case EDIT_ALERT_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (patientId === action.extraData.patientId) {
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                getAlertsList(action.extraData.patientId)
                closeAlertSection()
              }
              break
            case ADD_MEDIA_FILE_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (patientId === action.extraData.patientId) {
                closeUpload()
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                if (action.payload.DrugScreen) {
                  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
                  listenerApi.dispatch(getPatientInfo(patientId))
                }
              }
              break
            default:
              break
          }
        },
      }),
    )
    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [])

  return null
}
